module.exports = __webpack_public_path__ + "img/icon_hezuo.d4bf5697.svg";